import React, { useState, useEffect } from 'react';
import { Parallax } from 'react-parallax';
import { useNavigate } from 'react-router-dom';
import './Blogs.css';

const featured = [
  { title: 'Time Travel for Rookies', excerpt: "Is travelling into the future possible?" },
  { title: 'Message to Aliens', excerpt: "If Earth successfully sends a probe to an exoplanet with aliens, what would the message be?" },
  { title: 'Art of Deductions', excerpt: "Basic prediction based off of subtle tells and features" },
  { title: 'Decision Making In Machines', excerpt: "Can machines have emotions?" },
  { title: 'Anamorphic Art Basics', excerpt: "Bringing life to simple 2d art" },
];

const topics = [
  'Space',
  'Aliens',
  'Psychology',
  'Art',
  'AI'
];

export default function Blogs() {
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();

  // rotate featured topics every 5s
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % featured.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <Parallax
      bgImage="/assets/WhiteSandsRocketCropped.webp"      // put your parallax image in public/assets
      strength={300}
      bgImageStyle={{ minHeight: '100vh' }}
    >
      <div id="blogs" className="blogs-hero">
        <h1 className="blogs-page-title">Blogs</h1>

        <div className="blogs-content">
          {/* LEFT PANEL */}
          <div className="panel left-panel">
            <h2 className="section-title">Latest Articles</h2>
            <div className="slider-container glass-container">
              <div
                className="slides"
                style={{ transform: `translateX(-${idx * 100}%)` }}
              >
                {featured.map((f, i) => (
                  <div key={i} className="slide">
                    <h3>{f.title}</h3>
                    <p>{f.excerpt}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT PANEL */}
          <div className="panel right-panel">
            <h2 className="section-title">Posts</h2>
            <div className="stats-container glass-container">
              <p><strong>Total Posts:</strong> {featured.length}</p>
              <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
            </div>

            <h2 className="section-title">Topics Covered</h2>
            <div className="topics-container glass-container">
              <ul>
                {topics.map((t, i) => <li key={i}>{t}</li>)}
              </ul>
            </div>
            <div className="cta-container">
              <button onClick={() => navigate('/all-blogs')}>
                Check Out All Blogs
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="image-description">
            Image: White Sands
        </div>
    </Parallax>
  );
}
